import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { SurveyDetailsAndDashboardViews, SurveyDetailsAndDashboardViewsDTO } from "./surveyDetailsAndDashboardViews";
/* eslint-disable import/export */
export abstract class ManageDashboardViewSpocsRPC implements
  LeoRPC<ManageDashboardViewSpocsRPC.Request, ManageDashboardViewSpocsRPC.Response, ManageDashboardViewSpocsRPC.Errors.Errors>
{
  abstract execute(
    request: ManageDashboardViewSpocsRPC.Request
  ): Promise<LeoRPCResult<ManageDashboardViewSpocsRPC.Response, ManageDashboardViewSpocsRPC.Errors.Errors>>;
}

export namespace ManageDashboardViewSpocsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  
  export namespace RequestEnums {
    export namespace ViewAccessType {
      export interface ProjectDTO {
        case: string;
      }
      
      export class Project {
        readonly isViewAccessTypeProject: boolean = true;
      
      
      
      
      
        toDTO(): ProjectDTO {
          const dto: ProjectDTO = {
            case: "PROJECT",
          };
          return dto;
        }
        }
      
      Project.prototype.toString = function toString(): string {
        return `ViewAccessType.PROJECT()`;
      };
      
      export interface SpocsDTO {
        case: string;
        spocIds: string[];
      }
      
      export class Spocs {
        readonly isViewAccessTypeSpocs: boolean = true;
      
        readonly spocIds: LeoUUID[];
      
      
        constructor(
        spocIds: LeoUUID[]
        ) {
          this.spocIds = spocIds;
        }
      
        static fromDTO(dto: SpocsDTO): Spocs {
          const spocIds = getList<string, LeoUUID>(
            dto,
            "spocIds",
            (e: string) => new LeoUUID(e),
            InvalidRequestViewAccessTypeSpocsSpocIdsError
          );
          return new Spocs(
            spocIds
          );
        }
      
        toDTO(): SpocsDTO {
          const dto: SpocsDTO = {
            case: "SPOCS",
              spocIds: this.spocIds.map((e: LeoUUID) => { return e.toDTO(); })
          };
          return dto;
        }
        }
      
      Spocs.prototype.toString = function toString(): string {
        return `ViewAccessType.SPOCS(spocIds='${this.spocIds}')`;
      };
      
    
      export type ViewAccessType = Project | Spocs;
    
      export type ViewAccessTypeDTO = ProjectDTO | SpocsDTO;
    
      export const fromDTO = (dto: ViewAccessTypeDTO): ViewAccessType => {
        switch (dto.case) {
          case "PROJECT":
              return new Project();
          case "SPOCS":
              return Spocs.fromDTO(dto as SpocsDTO);
          default:
            throw new InvalidRequestViewAccessTypeError(
                `Case ${dto.case} is not valid case of ViewAccessType.`
            );
        }
      };
    }
    
  }
  export interface RequestDTO {
    projectId: string;
    surveyId: string;
    surveyViewId: string;
    viewAccessType: RequestEnums.ViewAccessType.ViewAccessTypeDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isManageDashboardViewSpocsRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
    readonly surveyId: LeoUUID;
    readonly surveyViewId: LeoUUID;
    readonly viewAccessType: RequestEnums.ViewAccessType.ViewAccessType;
  
  
    constructor(
    projectId: LeoUUID, 
    surveyId: LeoUUID, 
    surveyViewId: LeoUUID, 
    viewAccessType: RequestEnums.ViewAccessType.ViewAccessType
    ) {
      this.projectId = projectId;
      this.surveyId = surveyId;
      this.surveyViewId = surveyViewId;
      this.viewAccessType = viewAccessType;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      const surveyId = getLeoUuid(dto, "surveyId", InvalidRequestSurveyIdError);
      const surveyViewId = getLeoUuid(dto, "surveyViewId", InvalidRequestSurveyViewIdError);
      const viewAccessType = RequestEnums.ViewAccessType.fromDTO(getObject(dto, "viewAccessType", InvalidRequestViewAccessTypeError));
      return new Request(
        projectId,
        surveyId,
        surveyViewId,
        viewAccessType
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO(),
          surveyId: this.surveyId.toDTO(),
          surveyViewId: this.surveyViewId.toDTO(),
          viewAccessType: this.viewAccessType.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `ManageDashboardViewSpocsRPC(projectId='${this.projectId}',surveyId='${this.surveyId}',surveyViewId='${this.surveyViewId}',viewAccessType='${this.viewAccessType}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    surveyDetailsAndDashboardViews: SurveyDetailsAndDashboardViewsDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isManageDashboardViewSpocsResponse: boolean = true;
  
    readonly surveyDetailsAndDashboardViews: SurveyDetailsAndDashboardViews;
  
  
    constructor(
    surveyDetailsAndDashboardViews: SurveyDetailsAndDashboardViews
    ) {
      this.surveyDetailsAndDashboardViews = surveyDetailsAndDashboardViews;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const surveyDetailsAndDashboardViews = SurveyDetailsAndDashboardViews.fromDTO(getObject(dto, "surveyDetailsAndDashboardViews", InvalidResponseSurveyDetailsAndDashboardViewsError));
      return new Response(
        surveyDetailsAndDashboardViews
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          surveyDetailsAndDashboardViews: this.surveyDetailsAndDashboardViews.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `ManageDashboardViewSpocs(surveyDetailsAndDashboardViews='${this.surveyDetailsAndDashboardViews}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID",
    InvalidSurveyId = "INVALID_SURVEY_ID",
    InvalidSurveyViewId = "INVALID_SURVEY_VIEW_ID",
    InvalidSpocId = "INVALID_SPOC_ID",
    ProjectAlreadyArchived = "PROJECT_ALREADY_ARCHIVED",
    MasterSurveyViewCannotBeEdited = "MASTER_SURVEY_VIEW_CANNOT_BE_EDITED"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.INVALID_PROJECT_ID()`;
    };
    
    
    export interface InvalidSurveyIdDTO {
      code: string;
    }
    
    export class InvalidSurveyId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyIdDTO {
        const dto: InvalidSurveyIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyId.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.INVALID_SURVEY_ID()`;
    };
    
    
    export interface InvalidSurveyViewIdDTO {
      code: string;
    }
    
    export class InvalidSurveyViewId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyViewId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyViewId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyViewIdDTO {
        const dto: InvalidSurveyViewIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyViewId.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.INVALID_SURVEY_VIEW_ID()`;
    };
    
    
    export interface InvalidSpocIdDTO {
      code: string;
    }
    
    export class InvalidSpocId extends LeoRPCError<RPCError> {
      readonly isInvalidSpocId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSpocId;
        super(code);
      }
    
    
      toDTO(): InvalidSpocIdDTO {
        const dto: InvalidSpocIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSpocId.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.INVALID_SPOC_ID()`;
    };
    
    
    export interface ProjectAlreadyArchivedDTO {
      code: string;
    }
    
    export class ProjectAlreadyArchived extends LeoRPCError<RPCError> {
      readonly isProjectAlreadyArchived: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.ProjectAlreadyArchived;
        super(code);
      }
    
    
      toDTO(): ProjectAlreadyArchivedDTO {
        const dto: ProjectAlreadyArchivedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    ProjectAlreadyArchived.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.PROJECT_ALREADY_ARCHIVED()`;
    };
    
    
    export interface MasterSurveyViewCannotBeEditedDTO {
      code: string;
    }
    
    export class MasterSurveyViewCannotBeEdited extends LeoRPCError<RPCError> {
      readonly isMasterSurveyViewCannotBeEdited: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.MasterSurveyViewCannotBeEdited;
        super(code);
      }
    
    
      toDTO(): MasterSurveyViewCannotBeEditedDTO {
        const dto: MasterSurveyViewCannotBeEditedDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    MasterSurveyViewCannotBeEdited.prototype.toString = function toString(): string {
      return `ManageDashboardViewSpocsRPC.MASTER_SURVEY_VIEW_CANNOT_BE_EDITED()`;
    };
    

    export type Errors = InvalidProjectId | InvalidSurveyId | InvalidSurveyViewId | InvalidSpocId | ProjectAlreadyArchived | MasterSurveyViewCannotBeEdited;
    export type ErrorsDTO = InvalidProjectIdDTO | InvalidSurveyIdDTO | InvalidSurveyViewIdDTO | InvalidSpocIdDTO | ProjectAlreadyArchivedDTO | MasterSurveyViewCannotBeEditedDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        case RPCError.InvalidSurveyId:
          return new InvalidSurveyId();
        case RPCError.InvalidSurveyViewId:
          return new InvalidSurveyViewId();
        case RPCError.InvalidSpocId:
          return new InvalidSpocId();
        case RPCError.ProjectAlreadyArchived:
          return new ProjectAlreadyArchived();
        case RPCError.MasterSurveyViewCannotBeEdited:
          return new MasterSurveyViewCannotBeEdited();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends ManageDashboardViewSpocsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidRequestSurveyIdError extends ManageDashboardViewSpocsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyIdError";
  }
}

export class InvalidRequestSurveyViewIdError extends ManageDashboardViewSpocsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyViewIdError";
  }
}

export class InvalidRequestViewAccessTypeError extends ManageDashboardViewSpocsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestViewAccessTypeError";
  }
}

export class InvalidRequestViewAccessTypeProjectError extends InvalidRequestViewAccessTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestViewAccessTypeProjectError";
  }
}

export class InvalidRequestViewAccessTypeSpocsError extends InvalidRequestViewAccessTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestViewAccessTypeSpocsError";
  }
}

export class InvalidRequestViewAccessTypeSpocsSpocIdsError extends InvalidRequestViewAccessTypeSpocsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestViewAccessTypeSpocsSpocIdsError";
  }
}

export class InvalidResponseSurveyDetailsAndDashboardViewsError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseSurveyDetailsAndDashboardViewsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

export class InvalidResponseInvalidSurveyIdError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyIdError";
  }
}

export class InvalidResponseInvalidSurveyViewIdError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyViewIdError";
  }
}

export class InvalidResponseInvalidSpocIdError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSpocIdError";
  }
}

export class InvalidResponseProjectAlreadyArchivedError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectAlreadyArchivedError";
  }
}

export class InvalidResponseMasterSurveyViewCannotBeEditedError extends ManageDashboardViewSpocsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseMasterSurveyViewCannotBeEditedError";
  }
}

